import { useEffect, useState } from "react";
import Consent from "@/pages/participant/Consent";
import LabPicker from "@/pages/participant/LabPicker";
import { api } from "@/lib/api";

// In Single Griot mode there is nothing to choose: the landing page IS the one Griot.
export default function Entry() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.app().then(setCfg).catch(() => setCfg({ solo: false, lab: null }));
  }, []);

  if (!cfg) return <div style={{ minHeight: "100dvh", background: "var(--bg-primary)" }} data-testid="entry-loading" />;
  if (cfg.solo && cfg.lab) return <Consent solo slugOverride={cfg.lab.slug} />;
  return <LabPicker />;
}
